var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ToggleButton",on:{"click":_vm.onSelected}},[_c('button',{staticClass:"btn btn-lg btn-block",class:{'btn-info': _vm.value, 'btn-warning': !_vm.value}},[(!_vm.value)?_c('small',[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" "+_vm._s(_vm.label))]):_c('small',[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "+_vm._s(_vm.labelSelected))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dd75820","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Controls/ToggleButton.vue
// module id = null
// module chunks = 